export default __webpack_public_path__ + "static/media/unminting-empty-state-dark.994fae6a.svg";